"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const plumpingvolumeskin = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-plumpingvolumeskin` : '') + (description ? ` desc-plumpingvolumeskin` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-plumpingvolumeskin"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-plumpingvolumeskin"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.16 20.6a.75.75 0 0 1 0 1.5l-22.32.01a.75.75 0 0 1 0-1.5h22.32Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.52 16.27a5.59 5.59 0 0 1 6.28-.4l2.8 1.66a.75.75 0 0 1-.76 1.3l-2.8-1.67a4.09 4.09 0 0 0-4.6.3 5.61 5.61 0 0 1-6.85 0 4.16 4.16 0 0 0-4.7-.25l-2.65 1.64a.75.75 0 1 1-.8-1.28l2.66-1.64a5.66 5.66 0 0 1 6.4.34 4.11 4.11 0 0 0 5.02 0Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.52 11.47a5.59 5.59 0 0 1 6.28-.4l2.8 1.66a.75.75 0 0 1-.76 1.3l-2.8-1.67a4.09 4.09 0 0 0-4.6.3 5.61 5.61 0 0 1-6.85 0 4.16 4.16 0 0 0-4.7-.25l-2.65 1.64a.75.75 0 1 1-.8-1.28l2.66-1.64a5.66 5.66 0 0 1 6.4.34 4.11 4.11 0 0 0 5.02 0Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m6.53 1.05.05.01h.02l.06.02.08.03a.75.75 0 0 1 .24.16l2.25 2.25a.75.75 0 0 1-1.06 1.06l-.97-.97V8.4a.75.75 0 0 1-1.5 0V3.6l-.97.97a.75.75 0 1 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 .24-.16l.1-.03.04-.02h.02l.13-.01h.08Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.45 1.05h.08l.05.01h.02l.06.02.08.03a.75.75 0 0 1 .24.16l2.25 2.25a.75.75 0 0 1-1.06 1.06l-.97-.97V8.4a.75.75 0 0 1-1.5 0V3.6l-.97.97a.75.75 0 1 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 .24-.16l.1-.03.04-.02h.02l.13-.01Z",
    fill: "#232323"
  }));
};
var _default = exports.default = plumpingvolumeskin;